import { useState } from 'react';

import useSignerCrud from './useSignerCrud';
import useSignerReferenceData from './useSignerReferenceData';
import useSignerSelectors from './useSignerSelectors';

// Maneja de forma integrada la logica de firmantes, selectores, datos de referecia y CRUD.

export default function useSignersManagement({ t }) {
  // Estado de presentación.
  const [modal, setModal] = useState();
  const [modal2, setModal2] = useState();
  const [currentView, setCurrentView] = useState('list');
  const [typeAddSigner, setTypeAddSigner] = useState();

  const selectors = useSignerSelectors({
    t, 
  });
  const reference = useSignerReferenceData();
  const crud = useSignerCrud({
    t,
    selectors,
    setCurrentView,
    setModal2,
  });

  //Cerrar modal
  const handleModalClose = function () {
    setModal();
    selectors.resetSelectors();
  };

  return {
    ...selectors,
    ...reference,
    ...crud,
    modal,
    modal2,
    currentView,
    typeAddSigner,
    setModal,
    setModal2,
    setCurrentView,
    setTypeAddSigner,
    handleModalClose,
  };
}
